
import React from 'react';
import { TableCell, TableRow } from '@/components/ui/table';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Edit, Trash2 } from 'lucide-react';
import { User, UserRole } from '../../system/types';

interface UserTableRowProps {
  user: User;
  editing: boolean;
  onEditUser: (user: User) => void;
  onDeleteUser: (user: User) => void;
  roleLabels: Record<UserRole, string>;
}

const UserTableRow: React.FC<UserTableRowProps> = ({
  user,
  editing,
  onEditUser,
  onDeleteUser,
  roleLabels
}) => {
  const getRoleBadgeVariant = (role: UserRole) => {
    switch (role) {
      case 'admin': return 'default';
      case 'manager': return 'secondary';
      case 'operator': return 'outline';
      case 'viewer': return 'destructive';
      default: return 'default';
    }
  };

  return (
    <TableRow key={user.id}>
      <TableCell className="font-medium">{user.name}</TableCell>
      <TableCell>{user.email}</TableCell>
      <TableCell>
        <Badge variant={getRoleBadgeVariant(user.role)}>
          {roleLabels[user.role]}
        </Badge>
      </TableCell>
      <TableCell>{user.department}</TableCell>
      <TableCell>
        <Badge variant="outline">
          {user.directorySource === 'local' ? 'Local' : 'Active Directory'}
        </Badge>
      </TableCell>
      <TableCell>
        <Badge variant={user.status === 'active' ? 'default' : 'secondary'}>
          {user.status === 'active' ? 'Active' : 'Inactive'}
        </Badge>
      </TableCell>
      <TableCell className="text-right">
        <div className="flex justify-end gap-2">
          <Button 
            variant="ghost" 
            size="icon"
            disabled={!editing || user.directorySource !== 'local'}
            onClick={() => onEditUser(user)}
          >
            <Edit className="h-4 w-4" />
          </Button>
          <Button 
            variant="ghost" 
            size="icon"
            disabled={!editing || user.directorySource !== 'local'}
            onClick={() => onDeleteUser(user)}
          >
            <Trash2 className="h-4 w-4" />
          </Button>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default UserTableRow;
